export default function timeFromMilitary (timeNum){
  if (timeNum === null || timeNum === undefined) return '';

  const s = String(timeNum).padStart(4, '0');
  const hh = parseInt(s.slice(0, 2), 10);
  const mm = s.slice(2);

  // Convert to 12h format
  const period = hh >= 12 ? 'PM' : 'AM';
  const hour12 = hh % 12 === 0 ? 12 : hh % 12;

  const standard = `${hour12}:${mm} ${period}`;

  return standard;
};